import {createRoute, dynamicWrapper} from '@/utils/core';

const routesConfig = (app) => ({
    path: '/fire/index',
    title: '燃气监控指挥中心',
    component: dynamicWrapper(app, [], () => import('./components'))
});

export default (app) => createRoute(app, routesConfig);
